import { Alert, Snackbar } from '@aura/components'
import { withStyles } from '@aura/components/styles'
import PropTypes from 'prop-types'
import { useState } from 'react'
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined'
import { NotificationType } from '../../types'
import styles from './styles'


const Component = ({
    classes,
    duration,
    notification,
    onRemove
}) => {

    const [ open, setOpen ] = useState(true)

    const onClose = () => setOpen(false)

    const onExited = () => onRemove(notification)

    return (
        <Snackbar
            className={classes.root}
            open={open}
            autoHideDuration={duration}
            onClose={onClose}
            TransitionProps={{ onExited }}
        >
            <Alert
                className={classes.alert}
                onClose={onClose}
                severity={notification.type}
                iconMapping={{
                    success: <CheckCircleOutlineOutlinedIcon className={classes.successIcon} />
                }}
                variant="standard"
            >
                {notification.message}
            </Alert>
        </Snackbar>
    )
}


Component.displayName = 'Notification'

Component.propTypes = {
    classes: PropTypes.shape({
        alert: PropTypes.string.isRequired,
        root: PropTypes.string.isRequired,
        successIcon: PropTypes.string.isRequired
    }).isRequired,
    duration: PropTypes.number,
    notification: NotificationType.isRequired,
    onRemove: PropTypes.func.isRequired
}

Component.defaultProps = {
    duration: 10000
}

export default withStyles(Component, styles)
